import React, { useRef, useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './LoginPage.css';

function LoginPage() {
    const navigate = useNavigate();
    const { login } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const videoRef = useRef(null);

    // iOS/Safari 자동재생 보정
    useEffect(() => {
        const v = videoRef.current;
        if (!v) return;
        const tryPlay = () => v.play().catch(() => {});
        v.addEventListener('canplay', tryPlay, { once: true });
        return () => v.removeEventListener('canplay', tryPlay);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            await login(email, password);
            navigate('/intro');
        } catch (error) {
            if (error.status === 401) {
                setError('이메일 또는 비밀번호가 올바르지 않습니다.');
            } else if (error.status === 403) {
                setError('관리자 승인 대기 중입니다.');
            } else {
                setError(error.message || '로그인 중 오류가 발생했습니다.');
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="login-container">
            {/* === 배경 비디오 레이어 === */}
            <div className="bg-video">
                <video
                    ref={videoRef}
                    className="bg-video-el"
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload="metadata"
                    poster={`${process.env.PUBLIC_URL}/images/login-poster.jpg`}
                >
                    <source src={`${process.env.PUBLIC_URL}/videos/login-bg.mp4`} type="video/mp4" />
                </video>
                <div className="bg-overlay" />
            </div>

            {/* === 플로팅 배경 도형 === */}
            <div className="floating-shapes">
                <div className="shape shape-1"></div>
                <div className="shape shape-2"></div>
                <div className="shape shape-3"></div>
                <div className="shape shape-4"></div>
            </div>

            {/* === 로그인 카드 === */}
            <div className="login-box">
                <h1 className="logo">MAP Group CIS</h1>

                {error && <div className="error-message">{error}</div>}

                <form onSubmit={handleSubmit}>
                    <div className="input-group">
                        <label>이메일</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="이메일을 입력하세요"
                            required
                        />
                    </div>

                    <div className="input-group">
                        <label>비밀번호</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="비밀번호를 입력하세요"
                            required
                        />
                    </div>

                    <button type="submit" className="login-button" disabled={isLoading}>
                        {isLoading ? '로그인 중...' : '로그인'}
                    </button>
                </form>

                <div className="login-footer">
                    <span>계정이 없으신가요?</span>
                    <Link to="/signup" className="signup-link">회원가입</Link>
                </div>
            </div>
        </div>
    );
}

export default LoginPage;
